<template>
	<div class="app--loader" v-show="show"><i :class="classes"></i></div>
</template>

<script>
	export default {
		props: {
			icon: { type: String,  default: 'fas fa-circle-notch fa-spin' },
			show: { type: Boolean, required: true },
			size: { type: String,  default: ''    },
		},
		computed: {
			classes() { return this.icon + ' ' + this.size }
		}
	}
</script>
